import { Partner } from '@/components/Homepage';
import {
  Testimonials,
  VisionMissionValues,
  SEOHead,
  AllCertificates,
} from '@/components/Shared';
import Image from 'next/image';
import React from 'react';
import { motion } from 'framer-motion';
import { getCompanyAddressesJsonLd } from '@/constants/companyInfo';

const siteUrl = 'https://www.truongthofood.vn';

const organizationSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'Trường Thọ Food',
  url: siteUrl,
  logo: `${siteUrl}/logo-hori.png`,
  description:
    'Công ty chuyên cung cấp trứng gà tươi và trứng bóc vỏ sẵn chất lượng cao, đảm bảo vệ sinh an toàn thực phẩm',
  address: getCompanyAddressesJsonLd(),
  contactPoint: {
    '@type': 'ContactPoint',
    telephone: '+84-83-419-4986',
    contactType: 'customer service',
    email: 'truongthofood68@gmail.com',
    areaServed: 'VN',
    availableLanguage: ['Vietnamese'],
  },
  foundingDate: '2020',
  numberOfEmployees: {
    '@type': 'QuantitativeValue',
    value: '10-50',
  },
};

const About = () => {
  return (
    <>
      <SEOHead
        title="Về Chúng Tôi - Trường Thọ Food | Công Ty Trứng Gà Uy Tín"
        description="Tìm hiểu về Trường Thọ Food - Công ty chuyên cung cấp trứng gà tươi và trứng bóc vỏ sẵn chất lượng cao. Với nhiều năm kinh nghiệm, chúng tôi cam kết mang đến sản phẩm đảm bảo vệ sinh an toàn thực phẩm."
        keywords="về chúng tôi, công ty Trường Thọ, giới thiệu công ty, trứng gà uy tín, công ty trứng gà, Trường Thọ Food"
        image={`${siteUrl}/banner.png`}
        url={`${siteUrl}/about`}
        structuredData={organizationSchema}
      />
      <div>
      {/* Hero Banner */}
      <div className="flex w-full justify-center py-16 md:py-[84px] relative">
        <Image
          src={
            'https://i.pinimg.com/1200x/ef/50/c6/ef50c6412c96e75e362d3b1d2f3c3579.jpg'
          }
          alt="Banner trang về chúng tôi - Trường Thọ Food - Công ty trứng gà uy tín"
          fill
          style={{ objectFit: 'cover' }}
          className="absolute top-0 left-0 w-full h-full"
        />
        <div className="absolute top-0 left-0 w-full h-full bg-black opacity-50"></div>
        <p className="text-[24px] md:text-[32px] font-bold text-white z-10 relative uppercase">
          Về chúng tôi
        </p>
      </div>

      {/* Section 1: Hero với Nông dân */}

      {/* Section 2: Tầm nhìn, Sứ mệnh, Giá trị */}
      <VisionMissionValues />

      {/* Section 3: Giấy phép & Chứng nhận */}
      <AllCertificates />

      {/* Section 4: Testimonials */}
      <div className="bg-primary/5 py-8 md:py-16">
        <div className="container">
          <motion.div
            initial={{ opacity: 0, y: -20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="flex flex-col items-center text-center gap-4 mb-8 md:mb-12"
          >
            <p className="uppercase text-[24px] md:text-[32px] font-bold text-gray2">
              Khách hàng nói gì về chúng tôi
            </p>
            <p className="text-[16px] md:text-[18px] font-medium text-gray-600 max-w-3xl">
              Những phản hồi tích cực từ khách hàng là động lực để chúng tôi
              không ngừng cải thiện và phát triển
            </p>
          </motion.div>
          <Testimonials />
        </div>
      </div>

      {/* Section 3: Partners */}
      <div className="container py-8 md:py-16">
        <Partner />
      </div>
    </div>
    </>
  );
};

export default About;
